var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNpm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#CB3837;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2_",
    className: "st0",
    points: "67.5,178.8 67.5,300.7 169,300.7 169,321.2 250,321.2 250,300.7 432.5,300.7  432.5,178.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3_",
    className: "st1",
    points: "128.1,199.3 87.9,199.3 87.9,219.7 87.9,280.3 128.1,280.3 128.1,219.7 148.5,219.7  148.5,280.3 169,280.3 169,219.7 169,199.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st1",
    d: "M189.4,199.3v76.8v4.2v20.4h40.9v-20.4h40.2v-81H189.4z M250,259.9h-19.7v-40.2H250V259.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7_",
    className: "st1",
    points: "331,199.3 290.9,199.3 290.9,219.7 290.9,280.3 331,280.3 331,219.7 351.5,219.7  351.5,280.3 371.9,280.3 371.9,219.7 392.3,219.7 392.3,280.3 412.8,280.3 412.8,219.7 412.8,200.7 412.8,199.3  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpm);
export default __webpack_public_path__ + "static/media/npm.415fcfa105945a2dfd8d5ea7ef4817cd.svg";
export { ForwardRef as ReactComponent };